$(document).ready(function () {
    window.fbAsyncInit = function () {
        FB.init({
            appId: '1621499054772597',
            xfbml: true,
            version: 'v2.8'
        });
    };



    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/bg_BG/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
});